<template>
  <div class="job-list">
    <div class="job-list__controls">
      <b-img
        @click.prevent="next()"
        :src="require('@/assets/icons/arrow-right.svg')"
        :class="[
          'pointer',
          {
            disabled: loading || slides.length <= 1
          }
        ]"
      ></b-img>
      <b-img
        @click.prevent="prev()"
        :src="require('@/assets/icons/arrow-left.svg')"
        :class="[
          'mr-4 pointer',
          {
            disabled: loading || slides.length <= 1
          }
        ]"
      ></b-img>
    </div>
    <div v-if="loading" class="job-list__slider">
      <b-row>
        <b-col md="5" v-for="i in 2" :key="i">
          <card-shimmer></card-shimmer>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="text-center pt-3" v-if="similarJobs.length === 0">
        <p>Oops! Could not find any similar tools</p>
      </div>
      <div v-if="similarJobs.length !== 0">
        <b-carousel
          ref="carousel"
          v-model="slide"
          pause="hover"
          class="overflow-hidden"
          :interval="0"
        >
          <b-carousel-slide
            class="job-list__slider"
            v-for="(slide, index) in slides"
            :key="index"
          >
            <template v-slot:img>
              <b-row no-gutter>
                <b-col md="5" class="d-flex" v-for="job in slide" :key="job.id">
                  <job-item :job="job" />
                </b-col>
              </b-row>
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Carousel list of recently added Jobs
 * ==================================================================================
 **/

import { mapState } from 'vuex'
import JobItem from '@/components/cards/JobItem'
import CardShimmer from '@/components/shimmers/card'

export default {
  components: {
    JobItem,
    CardShimmer
  },

  computed: {
    ...mapState({
      job: state => state.job.jobDetails
    }),

    similarJobs() {
      return this.job ? this.job.related_tools : []
    },

    slides() {
      let result = []
      let rowLimit = 2
      for (
        var i = 0, length = this.similarJobs.length;
        i < length;
        i += rowLimit
      ) {
        result.push(this.similarJobs.slice(i, i + rowLimit))
      }
      return result
    }
  },

  data: function() {
    return {
      loading: false,
      slide: 0,
      limit: 8
    }
  },

  methods: {
    next() {
      if (!this.loading) {
        this.$refs.carousel.next()
      }
    },

    prev() {
      if (!this.loading) {
        this.$refs.carousel.prev()
      }
    }
  }
}
</script>
